import { createSlice } from "@reduxjs/toolkit";

export const manageAllSingleStates = createSlice({
  name: "manage_app_single_states",
  initialState: {
    value: { crop_disease_name: "", activate_account_link_route: false },
  },
  reducers: {
    updateCropName: (state, action) => {
      state.value.crop_disease_name = action.payload;
    },
    activateAccountLinkRoute: (state, action) => {
      state.value.activate_account_link_route = true;
    },
    deactivateAccountLinkRoute: (state, action) => {
      state.value.activate_account_link_route = false;
    },
  },
});

export const {
  updateCropName,
  activateAccountLinkRoute,
  deactivateAccountLinkRoute,
} = manageAllSingleStates.actions;

export default manageAllSingleStates.reducer;
